import React,{ useState, useEffect} from 'react';
import { useSelector, useDispatch, connect} from 'react-redux';
import { Divider, Loader, Icon,  } from 'rsuite';
import Radio from '@material-ui/core/Radio';
import $ from 'jquery';
import {generateAddressString}  from '../../../../../app/common/services/vehicle.service';
import * as actionsPolicy  from '../../../../../app/actions/policy';
import * as actionsUser  from '../../../../../app/actions/user';
import { NuInsInputTextLabel } from '../../elements/inputFieldsLabel';
import {CirclePlusIcon} from '../../svg/iconsSvg';
import NewAddress from '../NewAddress';


const SelectDeliveryAddress = ({updateShipmentDetails}) => {

    const dispatch = useDispatch();

    const userDetails     = useSelector(state => state.userDetails);
    const {userAddresses, userAddress}  = userDetails || {};

    const shipmentDetails = useSelector(state => state.shipmentDetails);
    const {deliveryAddress, receiverAddInfo} = shipmentDetails || {};

    const [sameAddressAsOwner, setSameAddressAsOwner] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        const fetchUserAddresses = async () => {
            setLoading(true);
            await dispatch(actionsUser.getUserAddresses());
            setLoading(false);
        }

        const updateUserAddress = async (address) => {
            setLoading(true);
            await dispatch(actionsUser.updateUserAddress(address));
            setLoading(false);
        }

        if(!userAddresses) {
            fetchUserAddresses();
        } else if(!userAddress || !Object.keys(userAddress).length) {
            //console.log('test')
            const address = userAddresses.find(obj => obj.isUserAddress);
            updateUserAddress(address);
        }

    }, [userAddresses, userAddress, dispatch]);

    useEffect(()=>{

        if(userDetails?.userAddress  && !deliveryAddress && (userDetails?.userAddresses?.length === 1)) {
            updateShipmentDetails({deliveryAddress: userDetails?.userAddress });
            setSameAddressAsOwner(true);
        }

    }, [userDetails, deliveryAddress, updateShipmentDetails]);

    useEffect(() => {
        $("body" ).on( "click", ".side_container-content", closeDrawer )

        return () => $("body" ).off( "click", ".side_container-content", closeDrawer );
    },[]);

    const onChangeHandler = (field, data) => {
        switch(field) {
            case 'sameAddressAsOwner':
                setSameAddressAsOwner(true);
                updateShipmentDetails({deliveryAddress: userAddress, receiverAddInfo: null });
                return
            case 'receiverAddInfo':
                updateShipmentDetails({receiverAddInfo: data });
                return
            default:
                updateShipmentDetails({[field]: data });
                return;
        } 
    }

    const selectDeliveryAddress = (addressId) => {
        const address = userAddresses.find(address=>address.addressId === addressId);
        updateShipmentDetails({deliveryAddress: address,  receiverAddInfo: null  });
        setSameAddressAsOwner(false);
    }

    const addAddress = (event) => {
        event.stopPropagation();
        setShowDrawer(true);
    }

    const closeDrawer = () => {
        setShowDrawer(false);
    }

    const onNewAddressSubmit = async (newAddress) => {
        //console.log(newAddress);
        closeDrawer();
        setLoading(true);

        await dispatch(actionsPolicy.addShipmentAddress(newAddress));

        setSameAddressAsOwner(false);

        setLoading(false);
    }

    const renderUserAddresses = () => {
        if(userAddresses) {
            const addresses = userAddresses.filter(address => !address.isUserAddress);
            return addresses.map((address, i) => {
                return (
                    <div key={i+1}>
                        <div className="steps_container-checkbox" style={{alignItems: 'start', paddingLeft: '23px'}}>
                            <Radio
                                checked={!sameAddressAsOwner && address.addressId === deliveryAddress?.addressId}
                                onChange={(data)=>selectDeliveryAddress(address.addressId)}
                                value=""
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B'+ i }}
                                />
                            <div style={{margin: '8px 0'}}>
                                <p>{generateAddressString(address)}</p>
                            </div>
                        </div>
                        { address.addressId === shipmentDetails?.deliveryAddress?.addressId &&
                            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('receiverAddInfo', data)}
                                placeholder={"Допълнителна информация за адреса"} 
                                value={receiverAddInfo} 
                                />
                            }
                        <Divider style={{margin: '8px 0'}}/>
                    </div>)
            });
        }

        return null;
    }

    return (
        <>
            <div className="steps_container-checkbox" style={{alignItems: 'start', paddingLeft: '23px'}}>
                <Radio
                    checked={sameAddressAsOwner}
                    onChange={(data)=>onChangeHandler('sameAddressAsOwner', data)}
                    value=""
                    name="radio-buttons"
                    inputProps={{ 'aria-label': 'A' }}
                    />
                <div>
                    <h6 style={{margin: '8px 0',fontWeight: '500'}}>Използвай моя адрес</h6>
                    <p>{generateAddressString(userDetails?.userAddress, true)}</p>
                </div>
            </div>
            { sameAddressAsOwner &&
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('receiverAddInfo', data)}
                placeholder={"Допълнителна информация за адреса"} 
                value={receiverAddInfo} 
                />
            }
            <Divider style={{marginTop: '20px', marginBottom: '8px'}}/>
            {renderUserAddresses()}

            <div className="steps_container-checkbox"  style={{cursor: 'pointer', marginTop: '8px'}} onClick={addAddress}>
                <CirclePlusIcon size={22} />
                <h6 style={{marginLeft: '10px', fontWeight: '500'}}>Добави нов адрес</h6>
            </div>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

             {/* -------------------------------Custom Drawer Start----------------------------------------------------------------- */}
             <div className={showDrawer ? "custom-drawer-backdrop" : "custom-drawer-backdrop_hide"}></div>
            <div className={showDrawer ? "custom-drawer_open" : "custom-drawer_close"} onClick={(event)=>{event.stopPropagation()}}>
                <div className="custom-drawer-head" >
                    <p className="header-secondary" style={{ fontWeight: '900'}}>Адрес за доставка</p>
                    <div className="head-icon" onClick={closeDrawer}><Icon icon="close" /></div>       
                </div>
                <Divider />
                <NewAddress onSubmit={onNewAddressSubmit} />
            </div>
        {/* ---------------------------------Custom Drawer End------------------------------------------------------------------ */}           
        </>
    )

}

export default connect(null, {...actionsPolicy})(SelectDeliveryAddress);